// src/pages/inventory/Movements.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import MovementsTable from "../../components/inventory/Movements/MovementsTable";

const Movements = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <MovementsTable />
    </WrapperSection>
);

export default Movements;
